import api from './api';

export const getAllJobPosts = async () => {
  try {
    const response = await api.get('/jobs');
    return response.data;
  } catch (error) {
    console.error('Error fetching job posts:', error);
    throw error;
  }
};

export const getJobPostById = async (id) => {
  try {
    const response = await api.get(`/jobs/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching job post with ID ${id}:`, error);
    throw error;
  }
};

export const createJobPost = async (jobData) => {
  try {
    const response = await api.post('/jobs', jobData);
    return response.data;
  } catch (error) {
    console.error('Error creating job post:', error);
    throw error;
  }
};

export const updateJobPost = async (id, jobData) => {
  try {
    const response = await api.patch(`/jobs/${id}`, jobData);
    return response.data;
  } catch (error) {
    console.error(`Error updating job post with ID ${id}:`, error);
    throw error;
  }
};

export const deleteJobPost = async (id) => {
  try {
    const response = await api.delete(`/jobs/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting job post with ID ${id}:`, error);
    throw error;
  }
};